import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_138_5813)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_138_5813" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "18",
      height: "18",
      fill: "white"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'fourDotsIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  size: {
    type: Number as PropType<number>,
    default: 18,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M3.75 7.5C5.82107 7.5 7.5 5.82107 7.5 3.75C7.5 1.67893 5.82107 0 3.75 0C1.67893 0 0 1.67893 0 3.75C0 5.82107 1.67893 7.5 3.75 7.5Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M14.25 7.5C16.3211 7.5 18 5.82107 18 3.75C18 1.67893 16.3211 0 14.25 0C12.1789 0 10.5 1.67893 10.5 3.75C10.5 5.82107 12.1789 7.5 14.25 7.5Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M3.75 18C5.82107 18 7.5 16.3211 7.5 14.25C7.5 12.1789 5.82107 10.5 3.75 10.5C1.67893 10.5 0 12.1789 0 14.25C0 16.3211 1.67893 18 3.75 18Z",
        fill: __props.color
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M14.25 18C16.3211 18 18 16.3211 18 14.25C18 12.1789 16.3211 10.5 14.25 10.5C12.1789 10.5 10.5 12.1789 10.5 14.25C10.5 16.3211 12.1789 18 14.25 18Z",
        fill: __props.color
      }, null, 8, _hoisted_6)
    ]),
    _hoisted_7
  ], 8, _hoisted_1))
}
}

})